import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setup-payee-invoice',
  templateUrl: './setup-payee-invoice.component.html',
  styleUrls: ['./setup-payee-invoice.component.css']
})
export class SetupPayeeInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
